import React from "react";

const Information = () => {
  return (
    <div className="information">
      <div className="information__box">
        <div className="information__header">
          <svg className="information__icon" aria-hidden="true">
            <use href="\sprite.svg#icon-closeTime"></use>
          </svg>
          <div className="information__title">Important Note</div>
        </div>
        <div className="information__text">
          Start your travel application with confidence! Please follow these simple yet important instructions to upload your documents correctly and avoid any delays.
        </div>
        <div className="information__steps">
          <div className="information__step">
            <div className="information__step-number">1</div>
            <div className="information__step-description">
              <strong>Photo:</strong>Upload a clear, well-lit photo with a white background. Your face should be fully visible and centered.
            </div>
          </div>
          <div className="information__step">
            <div className="information__step-number">2</div>
            <div className="information__step-description">
              <strong>Passport Front:</strong> Upload only the front page of your passport showing your details and photo.
            </div>
          </div>
          <div className="information__step">
            <div className="information__step-number">3</div>
            <div className="information__step-description"><strong>Passport Back:</strong> Upload only the back page of your passport — nothing else.</div>
          </div>
          <div className="information__step">
            <div className="information__step-number">4</div>
            <div className="information__step-description">
              <strong>File Formats:</strong> Supported formats are .jpg, .jpeg, .heic, and .png only.
            </div>
          </div>
          <div className="information__step">
            <div className="information__step-number">5</div>
            <div className="information__step-description">
              <strong>Avoid Issues:</strong> Make sure all images are clear, glare-free, and not blurry.
            </div>
          </div>
          <div className="information__step">
            <div className="information__step-number">6</div>
            <div className="information__step-description">
              <strong>Lighting:</strong> Take photos in a well-lit area and avoid shadows or dark spots.
            </div>
          </div>
           <div className="information__step">
            <div className="information__step-number">7</div>
            <div className="information__step-description">
              <strong>Extra Visa (if applicable):</strong> Upload your valid US or Schengen visa if required.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Information;
